<div>
  <shell-leal-toast
        type="error"
        icon="ti-clock"
        [time]="toastOptions.toastTime"
        content-title="¡Oh no!, tenemos un error de validación."
        content="Por favor verifica los datos ingresados e inténtalo nuevamente."
        id="lealToast"
        [isShowing]="toastOptions.isShowing"
        (closingToast)="closingToast()"
      />
  <app-login-form (showError)="showToast()"></app-login-form>
</div>
